<template>
  <div>
    <b-row class="mb-1">
      <b-col
        cols="12"
        md="3"
      >
        <b-form-group label="Supplier">
          <custom-v-select
            v-model="selectedSuppliers"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="supplierOptions"
            label="text"
            placeholder="Select Suppliers"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="Challan Number">
          <b-form-input
            v-model="challanNumber"
            type="text"
            placeholder="Search Challan Number"
            @input="debouncedFiltersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="Challan Date">
          <flat-picker
            v-model="challanDateRange"
            placeholder="Select Challan Date Range"
            :config="{ mode: 'range' }"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="Status">
          <custom-v-select
            v-model="selectedStatuses"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            label="text"
            placeholder="Select Status"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>

      <b-col
        cols="12"
        md="3"
      >
        <b-form-group label="CN Number of Company Document">
          <b-form-input
            v-model="cnNumberOfCompanyDocument"
            type="text"
            placeholder="Search CN Number"
            @input="debouncedFiltersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="CN Date of Company">
          <flat-picker
            v-model="cnDateOfCompanyRange"
            placeholder="Select CN Date of Company"
            :config="{ mode: 'range' }"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="CN Number of Issue Marg">
          <b-form-input
            v-model="cnNumberOfIssueMarg"
            type="text"
            placeholder="Search CN Number"
            @input="debouncedFiltersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="CN Date of Marg">
          <flat-picker
            v-model="cnDateOfMargRange"
            placeholder="Select CN Date of Marg"
            :config="{ mode: 'range' }"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <b-form-group label="CN Created Date">
          <flat-picker
            v-model="cnCreatedDateRange"
            placeholder="Select CN Created Date"
            :config="{ mode: 'range' }"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <div style="margin-top: 0.7rem">
          <b-form-checkbox
            :checked="cnCompanyCopy === 'uploaded'"
            style="margin-bottom: 0.3rem"
            @change="updateCnCompanyCopy('uploaded')"
          >
            CN Company Copy Uploaded
          </b-form-checkbox>
          <b-form-checkbox
            :checked="cnCompanyCopy === 'pending'"
            @change="updateCnCompanyCopy('pending')"
          >
            CN Company Copy Pending
          </b-form-checkbox>
        </div>
      </b-col>
      <b-col
        cols="12"
        md="2"
      >
        <div style="margin-top: 0.7rem">
          <b-form-checkbox
            :checked="actionRequired === true"
            @change="updateActionRequired(true)"
          >
            Action Required
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'
import FlatPicker from '@/components/UI/FlatPicker.vue'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import { debounce } from 'lodash'
import axios from 'axios'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    CustomVSelect,
    FlatPicker,
  },
  data() {
    const today = new Date()
    const from = new Date(today.getFullYear(), today.getMonth() - 5, 1)
    const to = new Date(today.getFullYear(), today.getMonth() + 1, 0)
    const pad = n => String(n).padStart(2, '0')
    const fmt = d => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

    return {
      supplierOptions: [],
      selectedSuppliers: [],
      challanNumber: null,
      challanDateRange: `${fmt(from)} to ${fmt(to)}`,
      statusOptions: [
        { text: 'Open', value: 'Open' },
        { text: 'Partially Adjusted', value: 'Partially Adjusted' },
        { text: 'Adjusted', value: 'Adjusted' },
      ],
      selectedStatuses: [],
      cnNumberOfCompanyDocument: null,
      cnDateOfCompanyRange: null,
      cnNumberOfIssueMarg: null,
      cnDateOfMargRange: null,
      cnCreatedDateRange: null,
      cnCompanyCopy: null,
      actionRequired: null,
    }
  },
  watch: {
    challanDateRange(newValue) {
      this.handleDateRangeChange(newValue)
    },
    cnDateOfCompanyRange(newValue) {
      this.handleDateRangeChange(newValue)
    },
    cnDateOfMargRange(newValue) {
      this.handleDateRangeChange(newValue)
    },
    cnCreatedDateRange(newValue) {
      this.handleDateRangeChange(newValue)
    },
  },
  created() {
    this.fetchOptions()
    this.filtersChangeHandler()
  },
  methods: {
    fetchOptions() {
      axios.get('/supplier_options')
        .then(res => {
          this.supplierOptions = res.data.data
        })
    },
    handleDateRangeChange(newValue) {
      if (newValue) {
        const [fromDate, toDate] = newValue.split(' to ')
        if (fromDate && toDate) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
    updateCnCompanyCopy(value) {
      this.cnCompanyCopy = this.cnCompanyCopy === value ? null : value
      this.filtersChangeHandler()
    },
    updateActionRequired(value) {
      this.actionRequired = this.actionRequired === value ? null : value
      this.filtersChangeHandler()
    },
    debouncedFiltersChangeHandler: debounce(function dummyName() {
      this.filtersChangeHandler()
    }, 500),
    getDateRangeFilter(keyPrefix, dateRange) {
      if (dateRange) {
        const [dateFrom, dateTo] = dateRange.split(' to ')
        if (dateFrom && dateTo) {
          return {
            [`${keyPrefix}_from`]: dateFrom,
            [`${keyPrefix}_to`]: dateTo,
          }
        }
      }
      return {}
    },
    filtersChangeHandler() {
      const filtersdata = {
        ...this.getDateRangeFilter('challan_date', this.challanDateRange),
        ...this.getDateRangeFilter('cn_date_of_company', this.cnDateOfCompanyRange),
        ...this.getDateRangeFilter('cn_date_of_marg', this.cnDateOfMargRange),
        ...this.getDateRangeFilter('cn_created_date', this.cnCreatedDateRange),
      }
      if (this.selectedSuppliers.length > 0) {
        filtersdata.suppliers = this.selectedSuppliers.map(item => item.id)
      }
      if (this.challanNumber) {
        filtersdata.challan_number = this.challanNumber
      }
      if (this.selectedStatuses.length > 0) {
        filtersdata.status = this.selectedStatuses.map(item => item.value)
      }
      if (this.cnNumberOfCompanyDocument) {
        filtersdata.cn_number_of_company_document = this.cnNumberOfCompanyDocument
      }
      if (this.cnNumberOfIssueMarg) {
        filtersdata.cn_number_of_issue_marg = this.cnNumberOfIssueMarg
      }
      if (this.cnCompanyCopy !== null) {
        filtersdata.cn_company_copy = this.cnCompanyCopy
      }
      if (this.actionRequired !== null) {
        filtersdata.action_required = this.actionRequired
      }
      this.$emit('filtersUpdated', filtersdata)
    },
  },
}
</script>
